/**
 * Saved export column sets ("export templates"), per shop, user and model. They live in this
 * browser only: a convenience, never data the shop depends on.
 */
export interface ExportTemplate {
  name: string;
  fields: string[];
}

const keyOf = (scope: string, model: string) => `sm.exportTemplates.${scope}.${model}`;

export function loadTemplates(scope: string, model: string): ExportTemplate[] {
  try {
    const raw = localStorage.getItem(keyOf(scope, model));
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (t): t is ExportTemplate =>
        typeof (t as ExportTemplate).name === 'string' &&
        Array.isArray((t as ExportTemplate).fields),
    );
  } catch {
    return [];
  }
}

export function saveTemplates(scope: string, model: string, templates: ExportTemplate[]): void {
  try {
    localStorage.setItem(keyOf(scope, model), JSON.stringify(templates));
  } catch {
    // Storage blocked or full: the template just isn't remembered.
  }
}
